import {getPrinterList, lodopPrint} from '@/const/lodopPrint'
import {labelPrint} from '@/const/labelPrint'
import EmisClient from '@/comp/lib/emisClient'

export async function print (printInfo, options) {
    if (printInfo.labelCategory === 'LODOP') {
        lodopPrint(printInfo, localStorage.getItem('emis-label-printer-lodop'))
    } else if (printInfo.labelCategory === 'LABEL') {
        await labelPrint(printInfo)
    } else if (printInfo.labelCategory === 'BARTENDER') {
        let client = new EmisClient()
        if (await client.isActivate()) {
            client.print(printInfo, options)
        } else {
            window.etao.message.toast('Print Client Not Running,Must Open EmisClient.exe', 'error')
        }
    }
}

export function printer (template) {
    let printerList = []
    if (template.category === 'LODOP') {
        printerList = getPrinterList()
    } else if (template.category === 'BARTENDER') {
        let client = new EmisClient()
        if (client.isActivate) {
            const printer = client.getPrinters()
            printerList = printer.printers
            localStorage.getItem('emis-label-printer-bartender', printer.defaultPrinter)
        } else {
            window.etao.message.toast('Print Client Not Running,Must Open EmisClient.exe', 'error')
        }
    }
    return printerList
}



// WEBPACK FOOTER //
// ./src/const/print.js